import * as PermissionHelpers from "Helpers/permissions";

// Permissions directive.
// Checks all supplied permissions, then performs appropriate UI
// changes.
// Supplied permissions are considered feature permissions by default, unless they
// contain the dot operator in which case the permission is considered to be an action.
// i.e:
//  `storage` is a feature
//  `storage.destroy` is an action
// UI changes are controlled by passing modifiers. Currently supported are:
// - `none`: no UI effect if permission checks fail
// - `disable`: sets the `disabled` property of the element to `true`
// - `hide`: sets the `style.visibility` property of the element to `hidden`
// - (default) `remove`: sets the `style.display` property of the element to `none`
// You _can_ pass multiple modifiers.
// You can also pass an (optional) callback as an argument. The callback is supplied
// with the element and directive bindings, and may do whatever it wants with these.
// This callback is always invoked _after_ modifiers are applied.
// Examples:
// <div v-perms="[`storage`, `storage.destroy`] />"
// <button v-perms.disable="[`feeds.store`]" />
// <div v-perms:[someCallback].remove="[`uploader_profiles`]" />
export default {
  bind: (el, binding) => {
    for (const check_str of binding.value) {
      const is_feature = !check_str.includes(`.`); // may need revision
      const check_fn = is_feature ?
        PermissionHelpers.permissionsCanAccessFeature :
        PermissionHelpers.permissionsCanDoAction;
      // if fail to pass, do ui things:
      if (check_fn(check_str) === false) {
        if (binding.modifiers.none) {
          break;
        }
        if (binding.modifiers.disable) {
          el.disabled = true;
          el.classList.add('cursor-not-allowed');
          const title = is_feature ? "You don't have permission to access this feature" : "You don't have permission to preform this action";
          el.setAttribute('title', title);
        }

        if (binding.modifiers.hide) {
          el.style.visibility = `hidden`;
        }
        if (binding.modifiers.remove || Object.keys(binding.modifiers).length === 0) {
          el.style.display = `none`;
        }
        break; // found a failure; no need to continue
      }
    }
    if (binding.arg) {
      binding.arg();
    }
  },
};
